import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43b183ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_2 = { class: "w-full bg-white p-6 rounded-md shadow-md flex flex-wrap gap-2 items-center justify-between" }
const _hoisted_3 = { class: "font-[800] text-neutral-900" }
const _hoisted_4 = { class: "bg-white p-6 rounded-md shadow-md flex justify-center items-center min-h-48" }
const _hoisted_5 = { class: "px-4 py-2 border border-h-primary-300 rounded-md text-h-info-700 cursor-move bg-gray-50 hover:bg-gray-100 transition-colors" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "flex flex-row flex-wrap items-center gap-2" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "px-2 py-2 border-h-primary-300 rounded-md border bg-gray-50 text-h-info-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_Draggable = _resolveComponent("Draggable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.questionCount) + "." + _toDisplayString(" " + _ctx.question?.prompt), 1),
      (_ctx.playAudio)
        ? (_openBlock(), _createBlock(_component_MessageVoice, {
            key: 0,
            msg: _ctx.msgVoice(_ctx.question.prompt),
            scaleIcons: 0.8,
            showIconsName: false,
            onOnEndMessage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSpeak($event)))
          }, null, 8, ["msg", "scaleIcons"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Draggable, {
        modelValue: _ctx.availableOptions,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.availableOptions) = $event)),
        "item-key": "id",
        group: "answers",
        class: "flex flex-wrap gap-2 w-full min-h-48",
        sort: false,
        clone: _ctx.cloneOption,
        move: _ctx.checkMove,
        id: "list-options"
      }, {
        item: _withCtx(({ element }) => [
          _createElementVNode("div", _hoisted_5, _toDisplayString(element.name), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "clone", "move"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedItems, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "mb-6 last:mb-0 bg-white p-6 rounded-md shadow-md flex flex-row items-center gap-2"
        }, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.renderLetterItem(index)), 1),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.parts, (part, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (part.type === 'text')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      innerHTML: part.content
                    }, null, 8, _hoisted_9))
                  : (_openBlock(), _createBlock(_component_Draggable, {
                      key: 1,
                      modelValue: part.selectedOption,
                      "onUpdate:modelValue": ($event: any) => ((part.selectedOption) = $event),
                      group: "answers",
                      class: _normalizeClass(["min-w-[120px] inline-block min-h-[36px]", [
                {
                  'border  rounded-md border-h-neutral-300 bg-neutral-50':
                    part.selectedOption.length === 0,
                },
              ]]),
                      "item-key": "id",
                      move: _ctx.checkMove
                    }, {
                      item: _withCtx(({ element }) => [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(element.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "class", "move"]))
              ], 64))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}